export function getNestedValue(data: any[], targetSgtins: string[]): any {
  const findSgtinInSubChild = (node: any, targetSgtin: string): any => {
    // If node is undefined, return undefined
    if (!node) return undefined

    // Handle parsedJsonDto array
    if (node.parsedJsonDto) {
      for (const item of node.parsedJsonDto) {
        if (item.sgtin === targetSgtin) {
          return item
        }
        // Check in subChild
        if (item.subChild) {
          for (const child of item.subChild) {
            if (child.sgtin === targetSgtin) {
              return child
            }
            // Recursively check child's subChild
            if (child.subChild) {
              const found = findSgtinInSubChild(child, targetSgtin)
              if (found) return found
            }
          }
        }
      }
    }

    // Check if current node matches
    if (node.sgtin === targetSgtin) {
      return node
    }

    // Check in subChild array
    if (node.subChild) {
      for (const child of node.subChild) {
        if (child.sgtin === targetSgtin) {
          return child
        }
        const found = findSgtinInSubChild(child, targetSgtin)
        if (found) return found
      }
    }

    // Check in epcisJsonList
    if (node.epcisJsonList) {
      for (const item of node.epcisJsonList) {
        const found = findSgtinInSubChild(item, targetSgtin)
        if (found) return found
      }
    }

    return undefined
  }

  let result = undefined

  // For each target SGTIN in sequence
  for (const targetSgtin of targetSgtins) {
    if (!result) {
      // First SGTIN: search from root
      for (const item of data) {
        const found = findSgtinInSubChild(item, targetSgtin)
        if (found) {
          result = found
          break
        }
      }
    } else {
      // Subsequent SGTINs: search in previous result
      result = findSgtinInSubChild(result, targetSgtin)
    }

    // If any SGTIN in the chain is not found, return undefined
    if (!result) return undefined
  }

  return result
}
